// ---------------
const isBrowser =
  typeof window !== "undefined" && typeof window.document !== "undefined";

// ---------------
export const Config = {
  temp: {
    incentive_number_of_show_types_prefix:
      "TEMP_INCENTIVE_NUMBER_OF_SHOW_TYPES_",

    incentive_number_of_entries_prefix: "TEMP_INCENTIVE_NUMBER_OF_ENTRIES_",
    incentive_number_of_entries_fee_percentage_prefix:
      "TEMP_INCENTIVE_NUMBER_OF_ENTRIES_FEE_PERCENTAGE_",

    incentive_number_of_entries_per_event_number_prefix:
      "TEMP_INCENTIVE_NUMBER_ENTRIES_PER_EVENT_NUMBER_",

    incentive_number_of_entries_per_day_prefix:
      "TEMP_INCENTIVE_NUMBER_ENTRIES_PER_DAY_",

    incentive_number_of_entries_per_show_prefix:
      "TEMP_INCENTIVE_NUMBER_ENTRIES_PER_SHOW_",

    incentive_number_of_entries_per_event_prefix:
      "TEMP_INCENTIVE_NUMBER_ENTRIES_PER_EVENT_",

    incentive_dogs_per_show_prefix: "TEMP_INCENTIVE_DOGS_PER_SHOW_",

    incentive_all_offered_classes_prefix: "TEMP_INCENTIVE_ALL_OFFERED_CLASSES_",

    incentive_junior_account_prefix: "TEMP_INCENTIVE_JUNIOR_ACCOUNT_",

    incentive_number_of_shows_prefix: "TEMP_INCENTIVE_NUMBER_OF_SHOWS_",
    //
    incentive_event_handles: process.env.TEMP_INCENTIVE_EVENT_HANDLES || "",
    incentive_min_show_types: parseInt(
      process.env.TEMP_INCENTIVE_MIN_SHOW_TYPES || "3"
    ),
    incentive_fee: parseInt(process.env.TEMP_INCENTIVE_FEE || "25"),
    extra_form_event_handle: process.env.TEMP_EXTRA_FORM_EVENT_HANDLE || "",
    extra_form_file_name: process.env.TEMP_EXTRA_FORM_FILE_NAME || "",
  },

  partner: {
    club_ids: (process.env.EAGERDOG_PARTNER_CLUB_IDS || "").split(","),
  },

  auth: {
    // JWT siging options for access token
    access_token_options: {
      secret: process.env.EAGERDOG_ACCESS_TOKEN_SECRET,
      expiresIn: process.env.EAGERDOG_ACCESS_TOKEN_DURATION || "5m",
    },

    // JWT siging options for refresh token
    refresh_token_options: {
      secret: process.env.EAGERDOG_REFRESH_TOKEN_SECRET,
      expiresIn: process.env.EAGERDOG_REFRESH_TOKEN_DURATION || "60m",
    },

    password_reset_token_options: {
      secret: process.env.EAGERDOG_PASSWORD_RESET_TOKEN_SECRET,
    },
  },

  // -------------
  eagerdog_api: {
    db_url: process.env.EAGERDOG_API_DB_URL || "",
    port: parseInt(process.env.EAGERDOG_API_PORT || "3001"),

    payload_max_size: process.env.EAGERDOG_API_PAYLOAD_MAX_SIZE || "1mb",
    internal_api_key:
      process.env.INTERNAL_API_KEY ||
      "your-internal-api-key-change-in-production",
    // Logs per-collection timings for GET /api/search (global search).
    search_debug: process.env.EAGERDOG_API_SEARCH_DEBUG === "true",

    // Social feed moderation. See data/prd/CONTENT_MODERATION_PRD.md.
    moderation: {
      // Distinct qualifying reports that hide a post from everyone but its
      // author and admins. 0 disables auto-hide.
      auto_hide_threshold: parseInt(process.env.EAGERDOG_MODERATION_AUTO_HIDE_THRESHOLD || "3"),
      // Reports from accounts younger than this are recorded but do not count
      // toward the threshold.
      reporter_min_account_age_days: parseInt(process.env.EAGERDOG_MODERATION_REPORTER_MIN_AGE_DAYS || "7"),
      suspension_days: parseInt(process.env.EAGERDOG_MODERATION_SUSPENSION_DAYS || "30"),
      // Screening runs at post creation. "enforce" changes status; "log"
      // records labels only; "off" skips the call. Default "off" until the
      // dry run has been reviewed (Phase 0 → 2).
      image_screening: (process.env.EAGERDOG_MODERATION_IMAGE_SCREENING || "off") as "off" | "log" | "enforce",
      text_screening: (process.env.EAGERDOG_MODERATION_TEXT_SCREENING || "off") as "off" | "log" | "enforce",
      screening_timeout_ms: parseInt(process.env.EAGERDOG_MODERATION_SCREENING_TIMEOUT_MS || "3000"),
      notify_email: process.env.EAGERDOG_MODERATION_NOTIFY_EMAIL || "support@eagerdog.com",
      rekognition_region: process.env.EAGERDOG_MODERATION_REKOGNITION_REGION || process.env.EAGERDOG_AWS_S3_REGION || "",
      openai_api_key: process.env.EAGERDOG_OPENAI_API_KEY || "",
    },
  },

  // -------------
  // Passed to MongooseModule.forRoot()/mongoose.connect() everywhere we
  // connect to MongoDB. Drops the driver's defaults (serverSelectionTimeoutMS
  // 30000ms, heartbeatFrequencyMS 10000ms) so that when a pooled connection
  // goes silently stale (e.g. a VPN or NAT dropping an idle socket without a
  // TCP RST), the driver notices and recovers in a few seconds instead of
  // blocking whichever request happens to hit it for up to 30 seconds -
  // which otherwise collides with client-side HTTP timeouts (e.g. the
  // mobile app's 30000ms axios timeout) and surfaces as a request timeout.
  mongoose_options: {
    serverSelectionTimeoutMS: 8000,
    heartbeatFrequencyMS: 5000,
    socketTimeoutMS: 20000,
  },

  // -------------
  eagerdog_webhooks_api: {
    port: parseInt(process.env.EAGERDOG_WEBHOOKS_API_PORT || "3001"),
  },

  // -------------
  eagerdog_cron_ms: {
    publish_events_cron:
      process.env.EAGERDOG_PUBLISH_EVENTS_CRON || "*/5 * * * *", // every 5 minutes
    waitlist_expiry_cron:
      process.env.EAGERDOG_WAITLIST_EXPIRY_CRON || "0 2 * * *", //daily at 2 AM
  },

  knock: {
    api_key: process.env.EAGERDOG_KNOCK_API_KEY || "",
  },

  // ------------
  eagerdog_notifications_ms: {
    transport_options: {
      // TCP = 0,
      // REDIS = 1,
      // NATS = 2,
      // MQTT = 3,
      // GRPC = 4,
      // RMQ = 5,
      // KAFKA = 6
      //transport: 0, //TCP
      transport: 5,
      // options: {
      //   host: process.env.DATA_DICT_CACHE_API_URL,
      //   port: parseInt(process.env.DATA_DICT_CACHE_API_PORT || '3000')
      // }
      options: {
        urls: [process.env.EAGERDOG_API_RMQ_URL || "amqp://localhost:5672"],
        queue:
          process.env.EAGERDOG_NOTIFICATIONS_MS_QUEUE_NAME || "notifications",
        queueOptions: {
          durable: false,
        },
      },
    },
  },

  // ------------
  eagerdog_forms_ms: {
    transport_options: {
      // TCP = 0,
      // REDIS = 1,
      // NATS = 2,
      // MQTT = 3,
      // GRPC = 4,
      // RMQ = 5,
      // KAFKA = 6
      //transport: 0, //TCP
      transport: 5,
      // options: {
      //   host: process.env.DATA_DICT_CACHE_API_URL,
      //   port: parseInt(process.env.DATA_DICT_CACHE_API_PORT || '3000')
      // }
      options: {
        urls: [process.env.EAGERDOG_API_RMQ_URL || "amqp://localhost:5672"],
        queue: process.env.EAGERDOG_FORMS_MS_QUEUE_NAME || "forms",
        //noAck: false,
        prefetchCount: 1, // maximum 1 forms processed at once
        queueOptions: {
          durable: false,
        },
        socketOptions: {
          heartbeatIntervalInSeconds: 60, // Increase heartbeat timeout for long-running Excel generation
        },
      },
    },
  },

  // ------------
  eagerdog_main_api: {
    transport_options: {
      transport: 5, // RMQ
      options: {
        urls: [process.env.EAGERDOG_API_RMQ_URL || "amqp://localhost:5672"],
        queue: process.env.EAGERDOG_MAIN_API_QUEUE_NAME || "main_api",
        queueOptions: {
          durable: false,
        },
      },
    },
  },

  aws_s3: {
    client_options: {
      accessKeyId: process.env.EAGERDOG_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.EAGERDOG_AWS_S3_SECRET_KEY,
      region: process.env.EAGERDOG_AWS_S3_REGION,
    },
    bucket: process.env.EAGERDOG_AWS_S3_BUCKET,
    acl: process.env.EAGERDOG_AWS_S3_ACL,
    max_file_size_mb: parseInt(
      process.env.EAGERDOG_AWS_S3_MAX_FILE_SIZE_MB || "50"
    ),
  },

  // Temporary storage (forms)
  aws_s3_temp: {
    client_options: {
      accessKeyId: process.env.EAGERDOG_AWS_S3_TEMP_ACCESS_KEY,
      secretAccessKey: process.env.EAGERDOG_AWS_S3_TEMP_SECRET_KEY,
      region: process.env.EAGERDOG_AWS_S3_TEMP_REGION,
    },
    bucket: process.env.EAGERDOG_AWS_S3_TEMP_BUCKET,
    acl: process.env.EAGERDOG_AWS_S3_TEMP_ACL,
    max_file_size_mb: parseInt(
      process.env.EAGERDOG_AWS_S3_TEMP_MAX_FILE_SIZE_MB || "50"
    ),
  },

  stripe: {
    api_key: process.env.EAGERDOG_STRIPE_SECRET_KEY || "",
    oauth_client_id: process.env.EAGERDOG_STRIPE_OAUTH_CLIENT_ID || "",
    connect_webhook_secret:
      process.env.EAGERDOG_STRIPE_CONNECT_WEBHOOK_SECRET || "",
    account_webhook_secret:
      process.env.EAGERDOG_STRIPE_ACCOUNT_WEBHOOK_SECRET || "",
  },

  revenuecat: {
    // Secret (sk_) API key; purchase state is always read back from RevenueCat with it
    secret_api_key: process.env.EAGERDOG_REVENUECAT_SECRET_API_KEY || "",
    // Optional: when set, must match the Authorization header on the RevenueCat webhook
    webhook_auth: process.env.EAGERDOG_REVENUECAT_WEBHOOK_AUTH || "",
    // Test Store purchases are free; never enable this in production
    allow_test_store: process.env.EAGERDOG_REVENUECAT_ALLOW_TEST_STORE === "true",
  },

  pricing: {
    // <=0 to disable
    max_application_fee: parseInt(
      process.env.EAGERDOG_MAX_APPLICATION_FEE_CENTS || "2500"
    ),
    donation_fee_percentage: 0.05,
  },

  //arm_number_config_prefix: "EAGERDOG_ARM_NUMBER", //EAGERDOG_ARM_NUMBER_AKC_Conformation=700

  puppeteer: {
    // needs to be adjusted for a docker image
    browser_options: {
      //headless: true,
      headless: "new",
      executablePath: process.env.EAGERDOG_PUPPETEER_BROWSER_PATH || "/usr/bin/google-chrome-stable",
      args: [
        "--no-sandbox",
        "--disable-setuid-sandbox",
        "--disable-dev-shm-usage",  // Critical for Docker: /dev/shm is only 64MB by default; without this Chromium crashes or spikes RAM
        "--disable-gpu",            // GPU not available in headless Docker
        "--no-first-run",
        "--no-zygote",
      ],
    },
    // Timeout for PDF generation (in milliseconds)
    // Default 30000ms (30s) is often too short for large judge books
    timeout: parseInt(process.env.EAGERDOG_PUPPETEER_TIMEOUT || "120000"), // 2 minutes default
  },

  web: {
    HOST: "0.0.0.0",
    REACT_APP_API_URL: isBrowser
      ? eval("window._env_.REACT_APP_API_URL")
      : process.env.REACT_APP_API_URL,
    REACT_APP_WEB_URL: isBrowser
      ? eval("window._env_.REACT_APP_WEB_URL")
      : process.env.REACT_APP_WEB_URL,
    REACT_APP_STRIPE_PUBLIC_KEY: isBrowser
      ? eval("window._env_.REACT_APP_STRIPE_PUBLIC_KEY")
      : process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    REACT_APP_GOOGLE_MAPS_API_KEY: isBrowser
      ? eval("window._env_.REACT_APP_GOOGLE_MAPS_API_KEY")
      : process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    REACT_APP_FULLCALENDAR_LICENSE_KEY: isBrowser
      ? eval("window._env_ && window._env_.REACT_APP_FULLCALENDAR_LICENSE_KEY")
      : process.env.REACT_APP_FULLCALENDAR_LICENSE_KEY,

    NODE_ENV: "development",
  },
};
